module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuand vous pensez à votre paysage patrimonial, qu'est-ce qui vous tient le plus à coeur ?\n\t\t")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.motivation),
      expression: "motivation"
    }],
    class: {
      error: _vm.errors.has('motivation')
    },
    attrs: {
      "name": "motivation",
      "placeholder": "Ex : Protéger votre conjoint(e), accompagner un enfant handicapé, préparer un tour du monde"
    },
    domProps: {
      "value": (_vm.motivation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.errors.first('motivation')) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tAuprès de qui prenez-vous conseil ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.conselors), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dae6dc46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Influence.vue
// module id = 1178
// module chunks = 0